var render, staticRenderFns
import script from "./GramBase.vue?vue&type=script&lang=ts"
export * from "./GramBase.vue?vue&type=script&lang=ts"
import style0 from "./GramBase.vue?vue&type=style&index=0&id=22a442de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a442de",
  null
  
)

export default component.exports